import React from "react";
import HeaderBase from "@vorne/gatsby-theme-marketing/components/header/header";
import NavBarTitle from "./navBarTitle";
import menuItems from "./menuItems";
import SubscriptionBar from "@vorne/gatsby-theme-marketing/components/subscriptionbar/subscriptionBar";

const Header = () => {
  return (
    <HeaderBase
      renderTitle={() => <NavBarTitle />}
      menuItems={menuItems}
      renderSubscriptionBar={() => (
        <SubscriptionBar
          bannerText="LEARN THE ART &amp; SCIENCE OF MANUFACTURING IMPROVEMENT "
          boldText="FROM VORNE"
          buttonText="LEARN MORE"
        />
      )}
    />
  );
};

export default Header;
